<template>
  <div id="invite">
    <BottomBar />
    <div v-if="rule === undefined || !user || !user.identity" class="empty">
      <inline-loading />
    </div>
    <div v-else>
      <section>
        <Top :rule="rule" />
        <Rules v-if="rule" />
      </section>
      <section>
        <Income v-if="rule" :rule="rule" />
      </section>
      <Courses v-if="rule && rule.list && rule.list.length" :rule="rule" />
      <router-link v-else tag="div" to="/courses/118?showShare=1" class="btn-primary">
        <i class="anyteachicon anyteach-ArtboardCopy" />去分享课程
      </router-link>
    </div>
  </div>
</template>

<script>
import BottomBar from "@/components/public/footer"
import Empty from "@/components/public/Empty"
import Swap from "@/components/invite/refer/Swap"
import Courses from "@/components/invite/refer/Courses"
import Rules from "@/components/invite/refer/Rules"
import Top from "@/components/invite/refer/Top"
import Income from "@/components/invite/refer/Income"

export default {
  name: "Invite",
  components: {
    Empty,
    BottomBar,
    Swap,
    Courses,
    Rules,
    Top,
    Income,
  },
  data() {
    return {
      record: 0,
      rule: undefined,
      shareUrl: null,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  watch: {
    user: function (val) {
      this.shareUrl = `${window.homePageUrl}/courses/118?friend=${this.user.user_id}`
      this.wechatShare()
    },
  },
  created() {
    this.getRule()
  },
  methods: {
    async getInviteRecord() {
      const res = await this.$api.user.GET_INVITE_RECORD()
      if (res) {
        this.record = res.filter(
          item =>
            item.refund.type == 12 &&
            item.user_type == this.user.identity &&
            item.refund.status != 3,
        ).length
      }
    },
    async getRule() {
      this.rule = await this.$api.invite.INCREASE_RULE_V3()
    },
    wechatShare() {
      this.$wxConfig()
      const title = `${this.user.name}邀请你来 AnyTeach 磨耳朵`
      const desc = "真人外教 | 互动直播 | 融合动画 | 趣味教学 👉"
      const imgUrl = window.logo2019

      wx.ready(() => {
        wx.updateAppMessageShareData({
          title,
          desc,
          link: this.shareUrl,
          imgUrl,
        })
        wx.updateTimelineShareData({
          title,
          link: this.shareUrl,
          imgUrl,
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import "./style.scss";
@import "../../../../static/css/transaction.scss";

@mixin btn() {
  $buttonWidth: 160px;
  @include avenir-demi();
  line-height: 42px;
  border-radius: 42px;
  width: $buttonWidth;
  height: 42px;
  box-sizing: content-box;
  margin: 0 auto;
  font-size: 0.9rem;
  border: 1px solid $red;
  transition: all 0.1s;
  text-align: center;
  &:active {
    opacity: 0.6;
  }
  i,
  span {
    font-size: inherit;
  }
  i {
    font-weight: 400;
    margin: 0 5px 0 0;
  }
}
.btn-primary {
  @include btn();
  color: white;
  background: $red;
}

#invite {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
}
</style>
